module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADiSURBVHgBpVLREYIwDE09/3UEnECdwI6AE8AGuoFsoBvICDiBbOAKMAFuUF8wHgVarpzv7l3aQF5e0yrywBizRtDgG6yUUhWFAsUnsDF9XEKLUym4sQthJrkkROAF3h35HHyGCDBSn7NhfkF/Yml14KnHsj04mumfE4SydytIxmY+tH0E7vxQE8D3DVPWJZjYAoyGPEC3HcKVvo+KUY9mYP0cIezQqJA9d9pjf3SJjwR4OHJl2y6lzuSB8xpRkInNWtZe2A6igUg+Ubeibh7tObWZj/bNKEskInksASjgsHXwAX9t8QEjUp5kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/form/check.png
// module id = rDxJ
// module chunks = 0